export const config = {
  domain: process.env.GATSBY_AUTH0_DOMAIN,
  client_id: process.env.GATSBY_AUTH0_CLIENT_ID,
  redirect_uri: process.env.GATSBY_AUTH0_CALLBACK_URL,
  responseType: process.env.GATSBY_AUTH0_RESPONSE_TYPE || 'token id_token',
  scope: process.env.GATSBY_AUTH0_SCOPE || 'openid email profile',
  audience: 'https://api.goodingco.com',
};
